import { TooltipMode } from './types'

export const DEFAULT_TOOLTIP_MODE: TooltipMode = 'icon'
